// src/api/llmGateway/llmGateway.ts
import { useApiClient } from "../apiClients";
import { LLM_GATEWAY_ENDPOINTS } from "./endpoints";
import type { GatewayProvidersResponse, KeyTestResult, ProviderKeyState } from "../../models/domain";

/**
 * La passerelle IA. Une clé saisie part dans le corps de la requête, vers la
 * passerelle seule : elle n'est ni gardée dans l'état de l'écran au-delà du
 * champ, ni journalisée, ni envoyée à tc_embed_be.
 */
export const useLlmGatewayApi = () => {
  const client = useApiClient("llm");

  const listGatewayProviders = () => client.get<GatewayProvidersResponse>(LLM_GATEWAY_ENDPOINTS.PROVIDERS);

  const putProviderKey = (id: string, apiKey: string) =>
    client.put<{ provider_id: string; key: ProviderKeyState; test: KeyTestResult }>(LLM_GATEWAY_ENDPOINTS.KEY(id), {
      api_key: apiKey,
    });

  /** `apiKey` absente : la passerelle teste la clé enregistrée. */
  const testProviderKey = (id: string, apiKey?: string) =>
    client.post<{ provider_id: string; candidate: boolean; test: KeyTestResult }>(
      LLM_GATEWAY_ENDPOINTS.TEST(id),
      apiKey ? { api_key: apiKey } : undefined,
    );

  const deleteProviderKey = (id: string) =>
    client.delete<{ provider_id: string; key: ProviderKeyState }>(LLM_GATEWAY_ENDPOINTS.KEY(id));

  return { listGatewayProviders, putProviderKey, testProviderKey, deleteProviderKey };
};
